import React from 'react';

const TextCarousel = () => {
  return (
    <div className="w-full overflow-hidden bg-gray-100 py-4 shadow-md">
      <div className="flex animate-scroll">
        <div className="flex-none w-full max-w-sm mx-4 text-center">
          <h3 className="my-2 text-lg font-semibold text-gray-800">20th May, 2024</h3>
          <p className="text-base text-gray-600">Full Paper Submission Deadline</p>
        </div>
        <div className="flex-none w-full max-w-sm mx-4 text-center">
          <h3 className="my-2 text-lg font-semibold text-gray-800">20th June, 2024</h3>
          <p className="text-base text-gray-600">Paper Acceptance Notification</p>
        </div>
        <div className="flex-none w-full max-w-sm mx-4 text-center">
          <h3 className="my-2 text-lg font-semibold text-gray-800">30th June, 2024</h3>
          <p className="text-base text-gray-600">Camera-Ready Paper Submission</p>
        </div>
        <div className="flex-none w-full max-w-sm mx-4 text-center">
          <h3 className="my-2 text-lg font-semibold text-gray-800">10th July, 2024</h3>
          <p className="text-base text-gray-600">Final Registration Deadline</p>
        </div>
        <div className="flex-none w-full max-w-sm mx-4 text-center">
          <h3 className="my-2 text-lg font-semibold text-gray-800">10th August, 2024</h3>
          <p className="text-base text-gray-600">Conference Date (Hybrid Mode)</p>
        </div>
        <div className="flex-none w-full max-w-sm mx-4 text-center">
          <h3 className="my-2 text-lg font-semibold text-gray-800">16th-17th August, 2024</h3>
          <p className="text-base text-gray-600">Conference Dates</p>
        </div>
      </div>
    </div>
  );
};

export default TextCarousel;
